import React from 'react'
import Navbar from '../Home/Navbar';
import Footer from '../Home/Footer';
import Header from './HeaderContact';
import FormContact from './FormContact';
import { CartProvider } from 'react-use-cart';

function AllContact() {
  return (
    <CartProvider>
        <Navbar/>
        <br/>
        <br/>
        <br/>
        <Header/>
        <FormContact/>
        <Footer/>
    </CartProvider>
  )
}

export default AllContact;